import React from "react";
import { capitalizeString } from "../../../../../utils/capitalizeString";
import { TextCustom } from "../../../../ui/TextCustom";
import { ErrorNotification } from "../../../../shared/ErrorNotification/ErrorNotification";

export const OverviewTableBody = (data: Record<string, unknown>, level = 0.5) => {

  if (typeof data !== 'object' || data === null) {
      return (
          <tr>
              <td colSpan={2} style={{ paddingLeft: `${level * 2}rem`, paddingTop: "1rem", paddingBottom: "1rem"}}>
                  <ErrorNotification error={"Invalid or missing data"} text={""} size={1.4} textSize={1.2} direction="v"/>
              </td>
          </tr>
      );
  }

  const dataItems = Object.keys(data);

  return dataItems.map((key) => {
      const value = data[key] as Record<string, unknown>;
      const isObject = typeof value === "object" && value !== null;

      return (
          <React.Fragment key={key}>
              <tr style={{ backgroundColor: `${isObject ? "white" : "white"}` }}>
                  <td style={{ paddingLeft: `${level * 2}rem`, paddingTop: ".5rem", paddingBottom: ".5rem" }}>
                      <TextCustom color={`${isObject ? "grey-normal" : "dark"}`} weight={isObject ? 500 : 500}>
                          {capitalizeString(key)}
                      </TextCustom>
                  </td>
                  <td style={{ paddingLeft: '1rem' }}>
                      <TextCustom color={"dark"} weight={isObject ? 400 : 400}>
                          {isObject ? "" : String(value ?? "")}
                      </TextCustom>
                  </td>
              </tr>
              {isObject && OverviewTableBody(value, level + 1)}
          </React.Fragment>
      );
  });
};

